import { MissingCostsEnum } from 'api';

export const displayMissingCost = (cost_code: MissingCostsEnum) => {
  switch (cost_code) {
    case MissingCostsEnum.LOCAL_ORIGIN_COST:
      return 'Origin Local Cost';
    case MissingCostsEnum.ORIGIN_DOC_FEE:
      return 'Origin Documentation Fee';
    case MissingCostsEnum.ORIGIN_INTERMODAL_COST:
      return 'Origin Road Cost';
    case MissingCostsEnum.OCEAN_FREIGHT_COST:
      return 'Ocean Freight Cost';
    case MissingCostsEnum.DESTINATION_INTERMODAL_COST:
      return 'Destination Road Cost';
    case MissingCostsEnum.LOCAL_DESTINATION_COST:
      return 'Destination Local Cost';
    case MissingCostsEnum.DESTINATION_TERMINAL_HANDLING_CHARGE:
      return 'Destination Terminal Handling Charge';
    case MissingCostsEnum.ORIGIN_TERMINAL_HANDLING_CHARGE:
      return 'Origin Terminal Handling Charge';
  }
};
